export default __webpack_public_path__ + "static/media/TibroProperty.0ce79338.png";